module.exports = {
      id: "launcher-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#launcher",
      toString: function () {
        return this.url;
      }
    }